/**
 * Recursively removes __typename fields from an object.
 * GraphQL adds __typename to all objects for type identification,
 * but mutations reject these fields as they're not part of the input schema.
 */
export function stripTypename(obj: any): any {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => stripTypename(item));
  }

  if (typeof obj === 'object') {
    const newObj: any = {};
    for (const key in obj) {
      if (key !== '__typename' && obj.hasOwnProperty(key)) {
        newObj[key] = stripTypename(obj[key]);
      }
    }
    return newObj;
  }

  return obj;
}